// eslint-disable-next-line import/named
import { removeHeader } from "libs/api/interceptors";

export default function tags(client, config) {
  const path = `/widgets/${config.widgetUUID}/tags`;
  return {
    checkTag: (data) => client.request({
      endpoint: path,
      method: "POST",
      body: data,
      interceptors: [
        // This is to call the API without any invalid credentials. Since this endpoint is open.
        removeHeader("Authorization"),
      ],
    }),
  };
}
